"use client";

import React from "react";
import { ButtonStyleType, SpacingType } from "@/types";
import { sectionVariants } from "@/types";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import parse from "html-react-parser";
import Image from '@/components/ui/Image';
import { SectionWrapper } from "../components/SectionWraper";
import { Badge } from "../ui/badge";

interface Feature27Props { 
  darkMode?: boolean; 
  variant?: sectionVariants;
  spacing?: SpacingType;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  removePaddingBottom?: boolean;
  themeChangeOnScroll?: boolean;
  badge?: string;
  title?: string;
  content?: string;
  hasButton?: boolean;
  buttonText?: string;
  buttonLink?: string;
  buttonStyle?: ButtonStyleType;
  image?: string;
  imageAltText?: string;
  attributes?: React.HTMLProps<HTMLElement>;
}

const Feature27 = ({
  darkMode = false,
  variant = "A",
  spacing,
  usedInPageNav = false,
  pageNavTitle = "Feature 15",
  removePaddingBottom = false,
  themeChangeOnScroll = false,
  badge,
  title,
  content,
  hasButton,
  buttonText,
  buttonLink,
  buttonStyle,
  image,
  imageAltText,
  attributes,
}: Feature27Props) => {
  
  return (
    <SectionWrapper
      usedInPageNav={usedInPageNav}
      pageNavTitle={pageNavTitle}
      removePaddingBottom={removePaddingBottom}
      themeChangeOnScroll={themeChangeOnScroll}
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="feature15"
      attributes={attributes}
    >

      <div className="container">
        <div className="flex flex-col justify-between gap-6 lg:flex-row" data-aos="fade-up">
          {title && (
            <div className="lg:w-3/5 text-center lg:text-left">
              {badge && (
                <Badge variant="outline" bold className="mb-6">
                  {badge}
                </Badge>
              )}
              <h2>
                {parse(title)}
              </h2>
            </div>
          )}
          {(content || hasButton) && (
            <div className="lg:w-2/5 flex flex-col gap-6">
               {hasButton && (
                <div className="hidden flex-col md:flex-row gap-4 lg:flex justify-end">
                  <div className="flex flex-col">
                    <Button asChild variant={buttonStyle} size="lg" className="w-full sm:w-auto">
                      <Link href={buttonLink ?? ""}>
                        {buttonText}
                      </Link>
                    </Button>
                  </div>
                </div>
              )}
              {content && (
                <div className="text-muted-foreground text-center lg:text-left">
                  {parse(content)}
                </div>
              )}
              {hasButton && (
                <div className="flex flex-col lg:flex-row gap-4 lg:hidden">
                  <div className="flex flex-col">
                    <Button asChild variant={buttonStyle} size="lg" className="w-full">
                      <Link href={buttonLink ?? ""}>
                        {buttonText}
                      </Link>
                    </Button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {image && (
          <div className="mt-16 w-full aspect-video" data-aos="fade-up" data-aos-delay={100}>
            <Image
              src={image}
              alt={imageAltText ?? ""}
              title={imageAltText ?? ""}
              width={1920}
              height={1080}
              className="aspect-video w-full object-cover"
            />
          </div>
        )}
        
      </div>
    </SectionWrapper>
  )
};

export { Feature27 };